// Account / account-group regex of routing and coverage rules. The API carries the bare pattern (`R01`),
// the UI marks a regex with a leading slash (`/R01`); the server may still return the CSV form (`/R01/`).
const REGEXP_MARKER = '/';

export const toApiRuleRegexp = (value?: string | null): string | undefined => {
  if (!value) {
    return undefined;
  }

  let pattern = value;
  if (pattern.startsWith(REGEXP_MARKER)) {
    pattern = pattern.slice(1);
    if (pattern.endsWith(REGEXP_MARKER)) {
      pattern = pattern.slice(0, -1);
    }
  }

  return pattern || undefined;
};

export const toUiRuleRegexp = (value?: string | null): string | undefined => {
  const pattern = toApiRuleRegexp(value);
  return pattern === undefined ? undefined : `${REGEXP_MARKER}${pattern}`;
};
